import React from "react";
import MDBox from "./MDBox";
import MDTypography from "./MDTypography";

export default function ModalHeader({ title }) {
  return (
    <MDBox
      variant="gradient"
      bgColor="info"
      borderRadius="lg"
      coloredShadow="info"
      mx={2}
      mt={-3}
      p={2}
      mb={1}
      textAlign="center"
    >
      <MDTypography variant="h5" fontWeight="medium" color="white" textTransform="uppercase">
        {title}
      </MDTypography>
    </MDBox>
  );
}
